// [sc-49210] Campi obbligatori di piastrelle e sanitari: le stesse regole
// sbloccano "Salva" in creazione e "Aggiorna" in modifica, e corrispondono
// agli asterischi delle etichette.

const text = (v) => (v == null ? "" : String(v)).trim().length > 0;

// numero inserito (anche 0): né vuoto né non numerico
const filled = (v) =>
  v !== "" && v != null && !Number.isNaN(Number(v)) && Number(v) >= 0;

/**
 * Piastrelle: nome, scatole (0 ammesso), pezzi per scatola, larghezza,
 * altezza, prezzo.
 */
export function isTileValid(f) {
  if (!f) return false;
  return (
    text(f.itemName) &&
    filled(f.boxQuantity) &&
    Number(f.piecesPerBox) >= 1 &&
    Number(f.widthCm) >= 1 &&
    Number(f.heightCm) >= 1 &&
    Number(f.price) > 0
  );
}

/**
 * Sanitari: tipo, posizione, brand (fa da nome), prezzo, quantità pezzi
 * (0 ammesso) e, per i vasi, pezzi coprivaso (0 ammesso).
 * Colore e linea/serie sono facoltativi.
 */
export function isSanitaryValid(f) {
  if (!f) return false;
  return (
    text(f.fixtureType) &&
    text(f.fixturePosition) &&
    text(f.brand) &&
    Number(f.price) > 0 &&
    filled(f.inWarehouse) &&
    (f.fixtureType !== "vaso" || filled(f.potQuantity))
  );
}
